import config from '__api/config';
import { zqhdApi } from '__api/zqhd/creatZqhdRequest';

/*增加用户抽奖次数*/
export async function addNewUserDraw() {
  const url = config.zqhpLink + '/activity/competition-welfare/addNewUserDrawTime';
  return zqhdApi.fetch(url);
}
